import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, MaskLines } from "./Reveal";
import { SectionBg } from "./SectionBg";
import { useLang } from "../../lib/i18n";

export const Process = () => {
  const { t, lang } = useLang();
  const steps = t("process.steps");
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <section id="process" ref={ref} data-testid="process-section" className="relative overflow-hidden py-24 sm:py-36 border-t hairline">
      <SectionBg src="/images/production-line.jpg" opacity={0.75} testId="process-bg" />
      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <p className="eyebrow mb-5">{t("process.eyebrow")}</p>
          <h2 key={lang} className="font-display font-bold tracking-[-0.03em] leading-[0.95] text-5xl sm:text-6xl">
            <MaskLines inView lines={[t("process.h1"), <span key="z" className="font-serif-i font-normal text-[var(--husk)]">{t("process.accent")}</span>]} delay={0} />
          </h2>
          <Reveal className="mt-10">
            <div className="relative overflow-hidden arch aspect-[4/5] max-w-md ring-1 ring-[#0F8A78]/40">
              <motion.img style={{ y, scale: 1.25 }} src="/images/plant.jpg" alt={t("process.alt")} className="h-full w-full object-cover" />
            </div>
          </Reveal>
        </div>
        <ol className="lg:col-span-7 lg:pt-28">
          {steps.map(([title, d], i) => {
            const n = `0${i + 1}`;
            return (
            <Reveal key={n} delay={i * 0.08}>
              <li data-testid={`process-step-${i + 1}`} className="group grid grid-cols-[auto_1fr] gap-6 sm:gap-10 border-t hairline py-8 sm:py-10">
                <span className="font-mono text-sm text-[var(--mint)] pt-2">{n}</span>
                <div>
                  <h3 className="font-display text-3xl sm:text-5xl font-semibold tracking-tight transition-transform duration-500 group-hover:translate-x-2">{title}</h3>
                  <p className="mt-3 max-w-lg text-[var(--sage)] leading-relaxed">{d}</p>
                </div>
              </li>
            </Reveal>
            );
          })}
        </ol>
      </div>
    </section>
  );
};
